import { useState } from "react";
import WorkScheduleTable from "../../../shared/work-schedule/WorkScheduleTable";

export default function WorkSchedule({ initialData, days }) {
  const [data, setData] = useState(initialData);

  return (
    <WorkScheduleTable
      title="Графік операторів"
      data={data}
      setData={setData}
      days={days}
      dayOrder="asc"
      allowAddOperator
    />
  );
}
